import { amber, red, blue, teal } from '@material-ui/core/colors';
import { Grid, Paper, Tooltip, Typography } from '@material-ui/core';
import { useCompanyMaster, useSnackbarInstance } from '@lib/common';
import { useCallback, useMemo, useState } from 'react';
import { Column } from 'react-table';
import { DraggableRowsTable } from '@components/draggable-rows-table';
import { ColoredChipIconButton } from '@components/colored-elements';
import { ImDrawer2, TrashFill, BiEdit } from '@icon/react-icons';
import { createContextQuick } from '@components/quick-context';
import getLoadingMessage from '@lib/common/loading-messages';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import { useBadgeMasterAutccomplete } from '@lib/common';
import { AssociatedPerson } from '@lib/company';
import styled from 'styled-components';
import { thumbStack } from '@lib/common/css';
import { ColoredAvatar, ColoredChip } from '@components/colored-elements';
import { Link } from 'react-router-dom';
import LaunchIcon from '@material-ui/icons/Launch';
import CopyClipboard from '@material-ui/icons/AttachFile';
import { createFormField } from '@pages/company/form/common';

export const CompanyQuotesPoliciesLoader = ({ value = null, onChange = null, isLock=null}) => {
  const { enqueue } = useSnackbarInstance();
  const onPersonAdd = useCallback(
    (person: AssociatedPerson) => {
      if (value && onChange) {
        if (
          !value.find(
            v =>
              v.person_vtr_id === person.person_vtr_id
          )
        ) {
          onChange([...value, person]);
        } else {
          enqueue(
            <>
              Associated Person &nbsp;<strong>{person.name}</strong>&nbsp; is already added.
            </>,
            { variant: 'error' }
          );
        }
      } else if (!value) {
        // Adding new person and the value is not usable.
        onChange([person]);
      }
    },
    [value, onChange]
  );

  const onPersonDelete = (person: AssociatedPerson) => {
    if (value && onChange) {
      const idx = value.findIndex(
        v => v.person_vtr_id === person.person_vtr_id && v.name === person.name
      );
      if (idx >= 0) {
        const nextValue = [...value];
        nextValue.splice(idx, 1);
        onChange(nextValue);
      }
    }
  };

  const onEditAssociatedPerson = (person: AssociatedPerson, idx?: number) => {
    if (value && onChange) {
      if (idx >= 0) {
        const nextValue = [...value];
        nextValue[idx] = person;
        onChange(nextValue);
      }
    }
  };

  const BadgeColumn: Column<any>[] = useMemo(
    () => [
      {
        Header: '#',
        id: 'serial',
        accessor: (_row, idx) => idx + 1,
        width: 35,
      },
      // {
      //   Header: 'Name',
      //   id: 'name',
      //   accessor: row => row.name,
      //   width: 200,
      // },
       {
         Header: 'Statement Date',
         id: 'statement_date',
         accessor: row => {
        const date = row?.statement_date ? new Date(row.statement_date) : null;

        return date
            ? date.toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              })
            : '';
        },
        width: 200,
      },
     {
        Header: 'Statement Type',
        id: 'statement_type',
        accessor: row => (row?.statement_type ? <Tooltip title="Visit Deal"><ColoredChipIconButton
          style={{"margin": 6, "paddingTop":5, "paddingLeft":10, "paddingBottom":5, "paddingRight":10}}
          color="primary"
          size="small"
          // icon={<LaunchIcon />}
          label={`${row?.statement_type}`}
        /></Tooltip> : 'DELI'),
        width: 200,
      },
      {
        Header: 'Person Name',
        id: 'person_name',
       accessor: row => row.person_name,
        Cell: ({ row }) => (
       
          <Typography variant="body2" display="block" style={{ whiteSpace: 'nowrap' }}>
                <ClipBoard
                  parentValue={row.original.person_name}
                  icon={<CopyClipboard style={{ fontSize: '1.2em' }} color="primary" />}
                  value={row.original.person_vtr_id}
                />
              </Typography>
        ),
        
      //  width: 500,
      },
      {
        Header: 'Person Vitrina Id',
        id: 'person_vtr_id',
        forceHide: true,
        accessor: row => (row.person_vtr_id ? row.person_vtr_id : row.vtr_id),
        width: 200,
      },
      {
        Header: 'Designation',
        id: 'designation',
        accessor: row => row?.designation,
        width: 200,
      },
        {
        Header: 'Statement',
        id: 'statement',
        accessor: row => row?.statement,
      //  width: 200,
      },
      {
        /*forceHide for this was making other columns extra large, had to just comment the code
        if you want to reactivate the column just uncomment the comment code below*/
        Header: 'Action',
      //  Header: '',
        id: 'actions',
        width: 80,
        Cell({ row}) {
       
          const [eachAssociatedPersonEdit, setEachAssociatedPersonEdit] = useState(false);
          const { deleteAssociatedPerson, editAssociatedPerson } = useActions();

          const onDeleteClick = () => deleteAssociatedPerson(row.original);
          const onEditClick = () => {
            setEachAssociatedPersonEdit(true);
          };
          const editAssociatedPersonFunction = (person, idx) => {
            editAssociatedPerson(person, idx);
            setEachAssociatedPersonEdit(false);
          };

          return (
            <>
             <Tooltip title="Edit">
                <span style={{ paddingRight: '5px' }}>
                    <ColoredChipIconButton
                    // onClick={e => !isLock ? onEditClick : e.preventDefault()}
                    disabled={isLock}
                   component={Link}
                   target='_blank'
                   to={`/quotes-policies/edit/${row?.original?.vtr_id}`}
                   pointer
                    color="primary"
                    size="small"
                    icon={<BiEdit />}
                    
                  />
                </span>
              </Tooltip> 
                 {/*   <AssociatedPersonPicker
                    onAssociatedPersonAdd={onPersonAdd}
                    onAssociatedPersonEdit={editAssociatedPersonFunction}
                    associatedPersonEditState={eachAssociatedPersonEdit}
                    editAssociatedPersonScenario={true}
                    editAssociatedPersonIndex={row.index}
                    editAssociatedPersonData={row.original}
                    setEachAssociatedPersonEdit={setEachAssociatedPersonEdit}
                  />
                </span>
              </Tooltip>
              <Tooltip title="Delete">
                <span>
                  <ColoredChipIconButton
                    onClick={onDeleteClick}
                    pointer
                    colored={red[900]}
                    size="small"
                    icon={<TrashFill />}
                    disabled={isLock}
                  />
                </span>
              </Tooltip> */}
            </>
          );
        },
      },
    ],
    [isLock]
  );
  return (
    <QuotesPoliciesContainer>
      <Grid container spacing={4} justify="center" alignItems="center">
        <Grid item>
          <Typography variant="h6" style={{ fontSize: 16 }}>
            Company's Quotes and Policies
          </Typography>
        </Grid>
        <Grid item xs />
        {/* <Grid item>
          <AssociatedPersonPicker onAssociatedPersonAdd={onPersonAdd} />
        </Grid> */}
      </Grid>
      {value && value.length ? (
        <Paper className="fixed-height">
          <ProvideEdit
            deleteAssociatedPerson={onPersonDelete}
            editAssociatedPerson={onEditAssociatedPerson}>
            <DraggableRowsTable
              getRowId={getAssociatedPersonRowId}
              onChange={onChange}
              columns={BadgeColumn}
              data={value}
              stickyHeader
              size="small"
              showDragIcon={false}
              // stopDrag={true}
            />
          </ProvideEdit>
        </Paper>
      ) : (
        EmptyContent
      )}
    </QuotesPoliciesContainer>
  );
};

const EmptyContent = (
  <Paper className="fixed-height no-data">
    <span>
      <ImDrawer2 />
      <br />
      <Typography>
        No <strong> Quotes & Polices</strong> added.
      </Typography>
    </span>
  </Paper>
);

const [ProvideEdit, useActions] = createContextQuick<{
  deleteAssociatedPerson?: (person: AssociatedPerson) => any;
  editAssociatedPerson?: (person: AssociatedPerson, idx?: number) => any;
}>();
const getAssociatedPersonRowId = (row, idx) => row.name + row.person_vtr_id + row.designation + idx;

export const CompanyQuotesPoliciesField = createFormField(CompanyQuotesPoliciesLoader, {
  defaultValue: [],
  passProps: true,
});


function ClipBoard({ parentValue, icon, display = 'block', value }) {
  const [isHovering, setHovering] = useState(false);
  const [isClick, setClick] = useState(false);
  return (
    <>
      <span
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => {
          setClick(false);
          setTimeout(() => {
            setHovering(false);
          }, 5000);
        }}>
        {parentValue}
      </span>
      <span
        style={{
          color: 'inherit',
          fontSize: 11,
          display: isHovering ? 'inline' : 'none',
          alignItems: 'center',
          paddingTop: '2px',
        }}>
        <Tooltip
          title={isClick ? 'Copied!!' : value}
          // arrow
          // followCursor
          onClick={() => {
            navigator.clipboard.writeText(value);
            setClick(true);
          }}>
          {icon}
        </Tooltip>
      </span>
    </>
  );
}
const QuotesPoliciesContainer = styled.div`
  padding: 10px 5px;
  background: #f5f5f5;
  table {
    td:nth-of-type(1) {
      padding-left: 10px;
      width: 40px;
    }
    th:nth-of-type(1) {
      padding-left: 10px;
      width: 40px;
    }
    // td:nth-of-type(2) {
    //   width: 35px;
    // }
    td:last-child {
      width: 80px;
    }
  }
  .drag-icon {
    cursor: grab;
  }
  .fixed-height {
    ${thumbStack}
    margin-top: 6px;
    margin-bottom: 6px;
    height: 40vh;
    position: relative;
    overflow: auto;
    .MuiTableContainer-root {
      ${thumbStack}
      height: inherit;
      overflow: inherit;
    }
    &.no-data {
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        text-align: center;
        svg {
          font-size: 4em;
          color: #ccc;
        }
      }
    }
  }
`;